import './DiscoApp.css'

import React from 'react'
import Modal from 'react-modal'

import DocumentHeadTags from 'components/document-head-tags'

import ExplorerWrapper from './ExplorerWrapper'

import '@disco/i18n/i18next'

Modal.setAppElement('#app')

const DiscoApp = ({
  loggedIn,
  bannersHeightPx,
}: {
  loggedIn: boolean
  bannersHeightPx?: number
}): React.ReactElement<'div'> => (
  <div className="Workspace e2root" data-banners-height-px={bannersHeightPx}>
    <DocumentHeadTags title="DISCO" />
    {loggedIn && <ExplorerWrapper />}
  </div>
)

export default DiscoApp
